import { truckApi } from "./truck.api";

export const { useGetIsTruckQuery } = truckApi;
